var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vz-page-loading-spinner",class:{ 'vz-active': _vm.active }},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vz-page-loading-spinner-spot"},[_c('i',{staticClass:"ic-loader vz-spin vz-page-loading-spinner-ic"})])
}]

export { render, staticRenderFns }